var GenericPageModule = (function () {
    function GenericPageModule() {
    }
    return GenericPageModule;
}());
export { GenericPageModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/generic-page/generic-page.module.ts.pre-build-optimizer.js